var _defs, _rect, _rect2, _circle, _path, _polygon, _polyline, _circle2, _polyline2, _rect3, _rect4, _polyline3, _polyline4, _polyline5, _rect5, _rect6, _path2, _rect7, _polyline6, _rect8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUniversity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 64 64",
    "data-name": "Layer 1",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f5dd90;\n      }\n\n      .cls-2 {\n        fill: #ffbc0a;\n      }\n\n      .cls-3 {\n        fill: #8b8c89;\n      }\n\n      .cls-4 {\n        fill: #6096ba;\n      }\n\n      .cls-5 {\n        fill: #274c77;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    height: 3,
    width: 2,
    x: 44,
    y: 18
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    height: 5,
    width: 2,
    x: 44,
    y: 11
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 45,
    cy: 17,
    r: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M24,12.87v2.13c0,2.21,1.79,4,4,4h8c2.21,0,4-1.79,4-4v-2.13l-8,2.13-8-2.13Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "32 15 17 11 32 3 47 11 32 15"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "20 59 20 33 32 21 44 33 44 59"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 32,
    cy: 35,
    r: 5
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "12 20 2 20 6 23 2 26 12 26"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    height: 20,
    width: 11,
    x: 9,
    y: 39
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    height: 20,
    width: 11,
    x: 44,
    y: 39
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "28 59 28 51 36 51 36 59"
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "44 33 57 33 57 39 44 39"
  })), _polyline5 || (_polyline5 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "20 39 7 39 7 33 20 33"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    height: 2,
    width: 60,
    x: 2,
    y: 59
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    height: 8,
    width: 2,
    x: 31,
    y: 51
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32,40c-2.76,0-5-2.24-5-5s2.24-5,5-5"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    height: 14,
    width: 2,
    x: 12,
    y: 19
  })), _polyline6 || (_polyline6 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "52 20 62 20 58 23 62 26 52 26"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    height: 14,
    transform: "translate(102 52) rotate(-180)",
    width: 2,
    x: 50,
    y: 19
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUniversity);
export default __webpack_public_path__ + "static/media/university.8657bf2fe22e980b296ca4a8607b50bf.svg";
export { ForwardRef as ReactComponent };